import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ProductBaseInfoFragmentDoc } from './Product.generated';
import { ReflectionBaseFragmentDoc } from './Reflection.generated';
import { RewardProgramFragmentDoc } from './RewardProgram.generated';
export type ProductDetailsFragment = { product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, specifics: Array<{ id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string, thumbnail: { lg: string | null, sm: string | null } }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } };

export const ProductDetailsFragmentDoc = gql`
    fragment ProductDetailsFragment on ProductVariantType {
  product {
    ...ProductBaseInfoFragment
    weight
    manufacturer {
      id
      name
    }
    specifics(filters: {siteSpecifics: true}) {
      ...ReflectionBaseFragment
      thumbnail {
        lg(size: "600x0", method: CROP_WEBP)
        sm(size: "300x0", method: CROP_WEBP)
      }
    }
    rewardPrograms {
      ...RewardProgramFragment
    }
  }
}
    ${ProductBaseInfoFragmentDoc}
${ReflectionBaseFragmentDoc}
${RewardProgramFragmentDoc}`;